import { Presence } from '@radix-ui/react-presence';
import { type Primitive } from '@radix-ui/react-primitive';
import { type ComponentPropsWithoutRef, type ComponentRef, forwardRef, memo } from 'react';

import { PanelContentImpl } from '~/components/v2/components/shared/panel/PanelContentImpl';
import {
  PANEL_CONTENT_NAME,
  type ScopeProps,
  usePanelContext,
} from '~/components/v2/components/shared/panel/PanelProvider';

export type PanelContentProps = ComponentPropsWithoutRef<typeof Primitive.div> & {
  forceMount?: boolean;
};

export const PanelContent = memo(
  forwardRef<ComponentRef<typeof Primitive.div>, ScopeProps<PanelContentProps>>(
    ({ __scopePanel, forceMount, ...restOfProps }, forwardedRef) => {
      const context = usePanelContext(PANEL_CONTENT_NAME, __scopePanel);

      return (
        <Presence present={forceMount || context.open}>
          {({ present }) => <PanelContentImpl {...restOfProps} ref={forwardedRef} present={present} />}
        </Presence>
      );
    },
  ),
);

PanelContent.displayName = 'PanelContent';
